'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _DescriptionWith3Columns = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns');

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptionWith3ColumnsContainer = function (_React$Component) {
  (0, _inherits3.default)(DescriptionWith3ColumnsContainer, _React$Component);

  function DescriptionWith3ColumnsContainer(props) {
    (0, _classCallCheck3.default)(this, DescriptionWith3ColumnsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (DescriptionWith3ColumnsContainer.__proto__ || (0, _getPrototypeOf2.default)(DescriptionWith3ColumnsContainer)).call(this, props));
  }

  (0, _createClass3.default)(DescriptionWith3ColumnsContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;

      return _react2.default.createElement(
        'div',
        { className: container },
        _react2.default.createElement(_DescriptionWith3Columns2.default, {
          title: props.title,
          headingBeforeBreak: props.headingBeforeBreak,
          headingAfterBreak: props.headingAfterBreak,
          desc: '',
          columns: props.columns
        })
      );
    }
  }]);
  return DescriptionWith3ColumnsContainer;
}(_react2.default.Component);

exports.default = DescriptionWith3ColumnsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DescriptionWith3ColumnsContainer/DescriptionWith3ColumnsContainer.jsx
// module id = 2606
// module chunks = 0